<template>
  <v-dialog :model-value="modelValue" max-width="600" @update:modelValue="$emit('update:modelValue', false)">
    <v-card class="pa-5">
      <v-card-title>Send Feedback</v-card-title>
      <v-card-subtitle>Our team wants to know</v-card-subtitle>

      <v-form v-model="feedbackFormValid">
        <v-card-text>
          <!-- Rating -->
          <div class="mb-4">
            <h3 class="text-subtitle-1 mb-2">How is your experience with Kinectin?</h3>
            <v-rating v-model="rating" hover length="5" color="primary"></v-rating>
          </div>

          <div class="mb-2">
            <v-textarea v-model="otherDetails" :rules="[rules.required]" variant="outlined"
                        label="Please help us understand the reason behind your rating"></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn prepend-icon="mdi-message-alert"
                 variant="text"
                 color="primary"
                 @click="handleFeedbackSubmit"
                 :disabled="!feedbackFormValid"
                 :loading="loading">
            Submit
          </v-btn>
          <v-btn @click="handleCancel" :disabled="loading">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import api from '@/service/Api.js'
import eventBus from '@/service/EventBus.js'
import { useKinectinStore } from '@/store/kinectin.js'
import pushNotifications from '@/service/pushNotifications.js'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: { type: Boolean, required: true },
})
const feedbackFormValid = ref(false)
const loading = ref(false)

// Form data
const rating = ref(0)
const otherDetails = ref('')
const screenshot = ref(null)
const store = useKinectinStore()

watch(rating, async () => {
  if (rating.value) await pushNotifications.addTags({ rating: rating.value })
  if ([4, 5].includes(rating.value) && await store.inAppReviewPromptable()) {
    await store.promptForInAppReview()
    clearAndClose()
  }
})

const rules = {
  required: v => !!v || 'Required',
}

function handleCancel() {
  mixpanel.track('Feedback - Cancelled')
  emit('update:modelValue', false)
}

async function handleFeedbackSubmit() {
  try {
    loading.value = true
    const feedback = {
      type: 'Kinectin Feedback',
      rating: rating.value,
      otherDetails: otherDetails.value,
      context: window.location.href,
    }
    mixpanel.track('Feedback - Submitted')
    await api.submitFeedback({ feedback })
    clearAndClose()
    eventBus.spa.emit('show-snackbar', { text: 'Thanks for your feedback!', color: 'green' })

  } catch (err) {
    eventBus.spa.emit('show-snackbar', { text: err, color: 'red' })
    console.error(err)
    throw err
  } finally {
    loading.value = false
  }
}

function clearAndClose() {
  emit('update:modelValue', false)
  rating.value = 0
  otherDetails.value = ''
  screenshot.value = null
}
</script>

<style scoped>
</style>
